export class UserVO {
    usuario: string;
    password: string;
    isMobile: boolean;
    i18n: string;
}